var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m9 13.97-3.9 2.05c-.87.45-1.44.04-1.28-.92l.75-4.33-3.16-3.06c-.7-.68-.48-1.35.49-1.49l4.36-.63 1.96-3.94c.43-.87 1.13-.87 1.56 0l1.96 3.94 4.36.63c.97.14 1.19.8.49 1.49l-3.16 3.06.75 4.33c.16.96-.4 1.37-1.27.92L9 13.97Z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgStar;